import { ApolloClient, createHttpLink, InMemoryCache } from "@apollo/client";
import { setContext } from "apollo-link-context";
import { getCookie } from "./cookies";

const httpLink = createHttpLink({
    uri: process.env.REACT_APP_API_HOST,
});

const authLink = setContext((_, { headers }) => {
    const token = getCookie("piap_jwt_token");

    return {
        headers: {
            ...headers,
            authorization: token ? `Bearer ${token}` : "",
        },
    };
});

const apolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
});

export default apolloClient;
